/**
 * useTranslation - returns t(key), locale, and setLocale.
 * Prefer I18nProvider; falls back to the shared locale store if context is absent.
 */

import { useI18nContext } from "@/lib/i18n/context";

export function useTranslation() {
  return useI18nContext();
}
